module.exports = __webpack_public_path__ + "static/pug_icon-342b077d765f6f29202e3e2e341a4ce0.png";